import BaseCarousel from './BaseCarousel';

export default BaseCarousel;
